import React, { useState, useEffect, useMemo } from 'react';
import {
  Box,
  Container,
  Paper,
  Tabs,
  Tab,
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Avatar,
  IconButton,
  Checkbox,
  FormControlLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Card,
  CardContent,
  Divider,
  Stack,
  Typography,
  styled,
  CircularProgress,
  Alert,
  Chip,
  ListItemText
} from '@mui/material';
import LanguageSelector from '../LanguageSelector'
import { useCredentials } from '../useCredentials';

import EditIcon from '@mui/icons-material/Edit';
import ProfileVisibilityMUI from '../ProfileSettings';
import PersonIcon from '@mui/icons-material/Person';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import LinkIcon from '@mui/icons-material/Link';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { login } from "./action/auth";
import { updateProfilecandidate } from "./action/auth";
import S3FileUpload from 'react-s3';
import AWS from 'aws-sdk';
import moment from "moment";
import defaultimg from './assets/defaultimge.png';
import { useAuthToken } from "../TokenContext";
import { useIntl } from 'react-intl';
import { v4 as uuidv4 } from 'uuid';
import { Link } from 'react-router-dom';
import axios from 'axios';

// Styled components
const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const PremiumPaper = styled(Paper)(({ theme }) => ({
  background: 'rgba(28, 35, 64, 0.9) !important',
  backdropFilter: 'blur(10px)',
  border: '1px solid rgba(255, 255, 255, 0.1)',
  borderRadius: '24px',
  boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
  overflow: 'hidden',
  transition: 'all 0.3s ease',
  color: '#ffffff',
  '&:hover': {
    boxShadow: '0 25px 70px rgba(0, 0, 0, 0.4)',
  }
}));

const ProfileAvatar = styled(Avatar)(({ theme }) => ({
  width: 120,
  height: 120,
  margin: '0 auto',
  border: `4px solid white`,
  boxShadow: '0 4px 14px 0 rgba(0,0,0,0.1)',
  cursor: 'pointer',
  transition: 'transform 0.3s ease',
  '&:hover': {
    transform: 'scale(1.05)',
  }
}));

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '0.95rem',
  marginRight: theme.spacing(1),
  transition: 'all 0.3s ease',
  minHeight: '48px',
  borderRadius: '12px',
  color: 'rgba(255, 255, 255, 0.7)',
  '&.Mui-selected': {
    background: 'rgba(255, 255, 255, 0.15)',
    color: '#ffffff',
    fontWeight: 700,
  },
  '&:hover': {
    background: 'rgba(255, 255, 255, 0.1)',
    color: '#ffffff',
  }
}));

const FileUploadButton = styled(Button)(({ theme }) => ({
  borderRadius: '12px',
  textTransform: 'none',
  padding: '8px 24px',
  fontWeight: 600,
  boxShadow: 'none',
  '&:hover': {
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
  }
}));

const ActionButton = styled(Button)(({ theme }) => ({
  borderRadius: '14px',
  padding: '12px 32px',
  textTransform: 'none',
  fontWeight: 700,
  fontSize: '1rem',
  background: `linear-gradient(45deg, ${theme.palette.primary.main} 30%, ${theme.palette.primary.light} 90%)`,
  color: 'white',
  boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 6px 10px 4px rgba(33, 203, 243, .3)',
  }
}));

const ModernTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '14px',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    transition: 'all 0.2s ease',
    '& fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.1)',
    },
    '&:hover fieldset': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.primary.light,
      borderWidth: '2px',
    },
  },
  '& .MuiInputLabel-root': {
    fontWeight: 600,
    color: 'rgba(255, 255, 255, 0.6)',
    '&.Mui-focused': {
      color: theme.palette.primary.light,
    }
  },
  '& .MuiOutlinedInput-input': {
    fontWeight: 500,
    color: '#ffffff',
  }
}));

// Configuration


// Constants
const area = [
  { value: 'Node', label: 'Node' },
  { value: 'Java', label: 'Java' },
  { value: 'React', label: 'React' },
  { value: 'Python', label: 'Python' },
  { value: 'AWS', label: 'AWS' },
  { value: 'C++', label: 'C++' }
];

const country = [
  { value: 'usa', label: 'USA' },
  { value: 'canada', label: 'Canada' },
  { value: 'india', label: 'India' },
  { value: 'australia', label: 'Australia' },
  { value: 'united_kingdom', label: 'United Kingdom' },
  { value: 'germany', label: 'Germany' },
  { value: 'france', label: 'France' },
  { value: 'china', label: 'China' },
  { value: 'japan', label: 'Japan' },
  { value: 'brazil', label: 'Brazil' },
  { value: 'south_africa', label: 'South Africa' },
  { value: 'mexico', label: 'Mexico' },
  { value: 'italy', label: 'Italy' },
  { value: 'spain', label: 'Spain' },
  { value: 'russia', label: 'Russia' },
  { value: 'south_korea', label: 'South Korea' },
  { value: 'new_zealand', label: 'New Zealand' },
  { value: 'singapore', label: 'Singapore' },
  { value: 'united_arab_emirates', label: 'United Arab Emirates' },
  { value: 'saudi_arabia', label: 'Saudi Arabia' },
  { value: 'argentina', label: 'Argentina' },
  { value: 'netherlands', label: 'Netherlands' },
  { value: 'sweden', label: 'Sweden' },
  { value: 'switzerland', label: 'Switzerland' },
  { value: 'norway', label: 'Norway' },
  { value: 'denmark', label: 'Denmark' },
  { value: 'finland', label: 'Finland' },
  { value: 'portugal', label: 'Portugal' },
  { value: 'poland', label: 'Poland' },
  { value: 'turkey', label: 'Turkey' },
  { value: 'indonesia', label: 'Indonesia' },
  { value: 'malaysia', label: 'Malaysia' },
  { value: 'thailand', label: 'Thailand' },
  { value: 'vietnam', label: 'Vietnam' },
  { value: 'philippines', label: 'Philippines' },
  { value: 'egypt', label: 'Egypt' },
  { value: 'nigeria', label: 'Nigeria' },
  { value: 'kenya', label: 'Kenya' },
  { value: 'ghana', label: 'Ghana' },
  { value: 'colombia', label: 'Colombia' },
  { value: 'chile', label: 'Chile' },
  { value: 'peru', label: 'Peru' },
  { value: 'venezuela', label: 'Venezuela' },
  { value: 'pakistan', label: 'Pakistan' },
  { value: 'bangladesh', label: 'Bangladesh' },
  { value: 'sri_lanka', label: 'Sri Lanka' },
  { value: 'nepal', label: 'Nepal' },
  { value: 'bhutan', label: 'Bhutan' },
  { value: 'maldives', label: 'Maldives' },
  { value: 'iceland', label: 'Iceland' },
  { value: 'luxembourg', label: 'Luxembourg' },
  { value: 'qatar', label: 'Qatar' },
  { value: 'oman', label: 'Oman' },
  { value: 'kuwait', label: 'Kuwait' },
  { value: 'bahrain', label: 'Bahrain' },
  { value: 'iraq', label: 'Iraq' },
  { value: 'iran', label: 'Iran' },
  { value: 'afghanistan', label: 'Afghanistan' },
  { value: 'israel', label: 'Israel' },
  { value: 'jordan', label: 'Jordan' },
  { value: 'lebanon', label: 'Lebanon' },
  { value: 'morocco', label: 'Morocco' },
  { value: 'algeria', label: 'Algeria' },
  { value: 'tunisia', label: 'Tunisia' },
  { value: 'libya', label: 'Libya' },
  { value: 'ethiopia', label: 'Ethiopia' },
  { value: 'tanzania', label: 'Tanzania' },
  { value: 'uganda', label: 'Uganda' },
  { value: 'zimbabwe', label: 'Zimbabwe' },
  { value: 'zambia', label: 'Zambia' },
  { value: 'mozambique', label: 'Mozambique' },
  { value: 'botswana', label: 'Botswana' },
  { value: 'namibia', label: 'Namibia' },
  { value: 'angola', label: 'Angola' },
  { value: 'cuba', label: 'Cuba' },
  { value: 'jamaica', label: 'Jamaica' },
  { value: 'haiti', label: 'Haiti' },
  { value: 'dominican_republic', label: 'Dominican Republic' },
  { value: 'trinidad_and_tobago', label: 'Trinidad and Tobago' },
  { value: 'bahamas', label: 'Bahamas' },
  { value: 'barbados', label: 'Barbados' },
  { value: 'panama', label: 'Panama' },
  { value: 'costa_rica', label: 'Costa Rica' },
  { value: 'honduras', label: 'Honduras' },
  { value: 'guatemala', label: 'Guatemala' },
  { value: 'el_salvador', label: 'El Salvador' },
  { value: 'nicaragua', label: 'Nicaragua' },
  { value: 'belize', label: 'Belize' },
  { value: 'paraguay', label: 'Paraguay' },
  { value: 'uruguay', label: 'Uruguay' },
  { value: 'bolivia', label: 'Bolivia' },
  { value: 'ecuador', label: 'Ecuador' },
  { value: 'guinea', label: 'Guinea' },
  { value: 'ivory_coast', label: 'Ivory Coast' },
  { value: 'cameroon', label: 'Cameroon' },
  { value: 'senegal', label: 'Senegal' },
  { value: 'sudan', label: 'Sudan' },
  { value: 'south_sudan', label: 'South Sudan' },
  { value: 'congo', label: 'Congo' },
  { value: 'madagascar', label: 'Madagascar' },
  { value: 'malawi', label: 'Malawi' },
  { value: 'sierra_leone', label: 'Sierra Leone' },
  { value: 'chad', label: 'Chad' },
  { value: 'mali', label: 'Mali' },
  { value: 'burkina_faso', label: 'Burkina Faso' },
  { value: 'rwanda', label: 'Rwanda' },
  { value: 'burundi', label: 'Burundi' },
  { value: 'lesotho', label: 'Lesotho' },
  { value: 'eswatini', label: 'Eswatini' }

];

const jobTitleOptions = [
  { value: 'UI/UX Designer', label: 'UI/UX Designer' },
  { value: 'Software Engineer', label: 'Software Engineer' },
  { value: 'Full-Stack Developer', label: 'Full-Stack Developer' },
  { value: 'Front-End Developer', label: 'Front-End Developer' },
  { value: 'Back-End Developer', label: 'Back-End Developer' },
  { value: 'Mobile Developer', label: 'Mobile Developer' },
  { value: 'QA Engineer', label: 'QA Engineer' },
  { value: 'Scrum Master', label: 'Scrum Master' },
  { value: 'Product Owner', label: 'Product Owner' },
  { value: 'Product Manager', label: 'Product Manager' },
  { value: 'Project Manager', label: 'Project Manager' }
];

const work_authorization = [
  { value: 'US Citizen', label: 'US Citizen' },
  { value: 'Permanent Resident', label: 'Permanent Resident' },
  { value: 'EAD', label: 'EAD' },
  { value: 'OPT-EAD', label: 'OPT-EAD' },
  { value: 'H4-EAD', label: 'H4-EAD' },
  { value: 'H1B', label: 'H1B' },
  { value: 'TN', label: 'TN' },
  { value: 'Not Applicable (NA)', label: 'Not Applicable (NA)' }
];

const techStack = [
  { value: 'MEAN', label: 'MEAN' },
  { value: 'MERN', label: 'MERN' },
  { value: 'LAMP', label: 'LAMP' },
  { value: 'MEVN', label: 'MEVN' }
];

const industry = [
  { value: 'Healthcare', label: 'Healthcare' },
  { value: 'IT & Software', label: 'IT & Software' },
  { value: 'Banking and Financial', label: 'Banking and Financial' },
  { value: 'Services', label: 'Services' }
];

const Updateyourprofile = ({ currentLocale, changeLocale, collapsed }) => {
  const { credentials, isLoaded, isLoading, refresh } = useCredentials();

  const token = useAuthToken();
  const intl = useIntl();
  const { isLoggedIn, user } = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const history = useHistory();


  // State management
  const [tabValue, setTabValue] = useState(0);
  const [edit, setEdit] = useState(false);
  const [image, setImage] = useState("");
  const [authImage, setAuthImage] = useState("");
  const [uploading, setUploading] = useState(false);
  const [resume, setResume] = useState("");
  const [assesment, setAssesment] = useState("");
  const [pod, setPod] = useState([]);
  const [portfolioItems, setPortfolioItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);




  const config = useMemo(() => ({
    bucketName: credentials.bucketName,
    region: credentials.region,
    accessKeyId: credentials.accessKeyId,
    secretAccessKey: credentials.secretAccessKey
  }), [credentials]);


  const S3Config = useMemo(() => ({
    bucketName: credentials.bucketName,
    region: credentials.region,
    accessKeyId: credentials.accessKeyId,
    secretAccessKey: credentials.secretAccessKey
  }), [credentials]);
  // Initialize AWS
  AWS.config.update(S3Config);
  const s3 = new AWS.S3();

  // Initial arrays
  const inputArr = [{
    degree: "",
    domain: "",
    institution: "",
    startDate: "",
    candidateID: user?.data?.[0]?.c_id || "",
    endDate: "",
    id: ""
  }];

  const expArray = [{
    work_organization: "",
    work_position: "",
    workStartdate: "",
    workEnddate: "",
    present: 0,
    candidateID: user?.data?.[0]?.c_id || "",
    id: ""
  }];

  const certificationArray = [{
    cert_name: "",
    candidateID: user?.data?.[0]?.c_id || "",
    startDate: "",
    endDate: "",
    certUrl: "",
    certificationInstitution: "",
    id: ""
  }];

  // State management for arrays
  const [arrexp1, setArrexp1] = useState(inputArr);
  const [arrCert, setArrCert] = useState(certificationArray);
  const [userexp, setUserexp] = useState(expArray);

  // Main state object with proper initialization
  const [state, setState] = useState({
    fname: "",
    mname: "",
    lname: "",
    candidateemail: "",
    area: "",
    github_repo_name: "",
    github_username: "",
    jira_username: "",
    sonarqube_project_key: "",
    country: "",
    job_title: "",
    primaryskill: "",
    secondaryskill: "",
    portfolio: "",
    linkedin: "",
    github: "",
    industry: "",
    about: "",
    techStack: "",
    email: "",
    resume: "",
    coding_assessment_url: "",
    work_authorization: "",
    timezone: "",
    availability: "",
    hoursperweek: "",
    currentStatus: "",
    availabledate: "",
    profilePicture: "",
    calendlyurl: "",
    talent_code: "",
    ratePerhour: "",
    ratePermonth: "",
    currency: "",
    workhours: ""
  });

  // Improved input handlers
  const onInputChange = e => {
    const { id, value } = e.target;
    setState(prevState => ({
      ...prevState,
      [id]: value
    }));
  };

  const onInputChangeselect = e => {
    const { name, value } = e.target;
    setState(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  /* istanbul ignore next */
  const addInput = () => {
    setArrexp1(prev => [...prev, { ...inputArr[0] }]);
  };

  /* istanbul ignore next */
  const addExp = () => {
    setUserexp(prev => [...prev, { ...expArray[0] }]);
  };

  /* istanbul ignore next */
  const addCert = () => {
    setArrCert(prev => [...prev, { ...certificationArray[0] }]);
  };

  const addNewPortfolioItem = () => {
    setPortfolioItems(prev => [...prev, { project_objective: '', project_description: '', industry: '', project_files: [] }]);
  };

  const removePortfolioItem = (idx) => {
    setPortfolioItems(prev => prev.filter((_, i) => i !== idx));
  };

  /* istanbul ignore next */
  const handleChangeExp = (e, idx, field) => {
    const value = field === 'present' ? (e.target.checked ? 1 : 0) : e.target.value;
    setUserexp(prev => {
      const newExp = [...prev];
      newExp[idx] = {
        ...newExp[idx],
        [field]: value
      };
      return newExp;
    });
  };

  /* istanbul ignore next */
  const handleChangeCert = (e, idx) => {
    const { id, value } = e.target;
    setArrCert(prev => {
      const newCert = [...prev];
      newCert[idx] = {
        ...newCert[idx],
        [id]: value
      };
      return newCert;
    });
  };

  /* istanbul ignore next */
  const handleChange = (e, idx) => {
    const { id, value } = e.target;
    setArrexp1(prev => {
      const newEdu = [...prev];
      newEdu[idx] = {
        ...newEdu[idx],
        [id]: value
      };
      return newEdu;
    });
  };

  const removeEducation = (idx) => {
    setArrexp1(prev => prev.filter((_, i) => i !== idx));
  };

  const removeExperience = (idx) => {
    setUserexp(prev => prev.filter((_, i) => i !== idx));
  };

  const removeCertification = (idx) => {
    setArrCert(prev => prev.filter((_, i) => i !== idx));
  };

  // File upload handlers with proper error handling
  /* istanbul ignore next */
  const onFileUpload = async e => {
    try {
      setUploading(true);
      const file = e.target.files[0];
      if (!file) return;

      const data = await S3FileUpload.uploadFile(file, config);
      setState(prevState => ({
        ...prevState,
        resume: data.key
      }));
    } catch (err) {
      console.error(err);
      setError('Failed to upload file');
    } finally {
      setUploading(false);
    }
  };

  /* istanbul ignore next */
  const onResumeUpload = async e => {
    try {
      setUploading(true);
      const file = e.target.files[0];
      if (!file) return;

      const data = await S3FileUpload.uploadFile(file, config);
      setState(prevState => ({
        ...prevState,
        resume: data.key
      }));
      setResume(prevState => ({
        ...prevState,
        resumeName: file.name,
        resumeKey: data.key
      }));
    } catch (err) {
      console.error(err);
      setError('Failed to upload resume');
    } finally {
      setUploading(false);
    }
  };

  /* istanbul ignore next */
  const onFileUploadassesment = async e => {
    try {
      setUploading(true);
      const file = e.target.files[0];
      if (!file) return;

      const data = await S3FileUpload.uploadFile(file, config);
      setState(prevState => ({
        ...prevState,
        coding_assessment_url: data.key
      }));
    } catch (err) {
      console.error(err);
      setError('Failed to upload assessment');
    } finally {
      setUploading(false);
    }
  };

  const onImageUpload = async e => {
    try {
      const file = e.target.files[0];
      if (!file) return;

      setImage(URL.createObjectURL(file));
      const data = await S3FileUpload.uploadFile(file, config);
      /* istanbul ignore next */
      if (data && data.key) {
        setState(prevState => ({
          ...prevState,
          profilePicture: data.key
        }));
      } else {
        throw new Error('Upload failed: Invalid response');
      }
    } catch (err) {
      console.error(err);
      setError('Failed to upload profile picture');
    }
  };

  // Toggle edit with proper state management
  const toggleEdit = (force = null) => {
    setEdit(prev => force !== null ? force : !prev);
    setError(null);
  };

  // Tab handling
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // Portfolio handlers
  /* istanbul ignore next */
  const addPortfolioItem = () => {
    setPortfolioItems(prev => [
      ...prev,
      {
        project_objective: '',
        project_description: '',
        industry: '',
        project_files: []
      }
    ]);
  };

  /* istanbul ignore next */
  const handlePortfolioItemChange = (index, field, value) => {
    setPortfolioItems(prev => {
      const updatedItems = [...prev];
      updatedItems[index] = {
        ...updatedItems[index],
        [field]: value
      };
      return updatedItems;
    });
  };

  /* istanbul ignore next */
  const handleImageChange = async (index, files) => {
    const updatedItems = [...portfolioItems];
    const imageUrls = await Promise.all([...files].map(uploadImageToS3)); // Assume uploadImageToS3 is a function that handles image upload
    updatedItems[index].project_files = imageUrls;
    setPortfolioItems(updatedItems);
  };

  /* istanbul ignore next */
  const handleUpdatePortfolio = async () => {
    try {
      const portfolioUserId = user?.data?.[0]?.type === 'Provider'
        ? user.data[0].id
        : user.data[0].c_id;

      const payload = portfolioItems.map(item => ({
        portfolio_id: item.portfolio_id || '',
        portfolio_user_id: portfolioUserId,
        project_objective: item.project_objective,
        project_description: item.project_description,
        industry: item.industry,
        project_files: item.project_files,
      }));

      const response = await axios.put(
        process.env.REACT_APP_TALENT_EDITPORTFOLIO,
        { educationdata: payload, type: "PORT" },
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status !== 200) {
        throw new Error('Failed to update portfolio');
      }

      return response.data;
    } catch (error) {
      console.error('Error updating portfolio:', error);
      throw new Error('Failed to update portfolio');
    }
  };

  // Form submission handler
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const headers = {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      };

      // First, create the profile data payload
      const profileData = {
        id: user.data[0].c_id,
        firstname: state.fname,
        middlename: state.mname,
        lastname: state.lname,
        industry: state.industry,
        techStack: state.techStack,
        primaryskill: state.primaryskill,
        secondaryskill: state.secondaryskill,
        country: state.country,
        job_title: state.job_title,
        linkedinurl: state.linkedin,
        githuburl: state.github,
        workhours: state.workhours,
        portfoliourl: state.portfolio,
        about: state.about,
        profilePicture: state.profilePicture,
        resume: state.resume,
        coding_assessment_url: state.coding_assessment_url,
        work_authorization: state.work_authorization,
        timezone: state.timezone,
        calendlyurl: state.calendlyurl,
        talent_code: state.talent_code,
        availability: state.availability,
        hoursperweek: state.hoursperweek,
        currentStatus: state.currentStatus,
        availabledate: state.availabledate,
        ratePerhour: state.ratePerhour,
        ratePermonth: state.ratePermonth,
        currency: state.currency,
        github_repo_name: state.github_repo_name,
        github_username: state.github_username,
        jira_username: state.jira_username,
        sonarqube_project_key: state.sonarqube_project_key
      };

      // Update main profile
      await dispatch(updateProfilecandidate(profileData, headers));

      // Update education if there's data
      /* istanbul ignore next */
      if (arrexp1.length > 0) {
        await axios.post(
          `${process.env.REACT_APP_TALENT_CANDIDATEPROFILETESTUPDATE}`,
          { educationdata: arrexp1, type: "EDU" },
          { headers }
        );
      }

      /* istanbul ignore next */
      if (userexp.length > 0) {
        await axios.post(
          `${process.env.REACT_APP_TALENT_CANDIDATEPROFILETESTUPDATE}`,
          { educationdata: userexp, type: "EXP" },
          { headers }
        );
      }

      /* istanbul ignore next */
      if (arrCert.length > 0) {
        await axios.post(
          `${process.env.REACT_APP_TALENT_CANDIDATEPROFILETESTUPDATE}`,
          { educationdata: arrCert, type: "CERT" },
          { headers }
        );
      }

      // Update portfolio if there's data
      /* istanbul ignore next */
      if (portfolioItems.length > 0) {
        const portfolioUserId = user.data[0].type === 'Provider' ? user.data[0].id : user.data[0].c_id;

        const portfolioPayload = portfolioItems.map(item => ({
          portfolio_id: item.portfolio_id || '',
          portfolio_user_id: portfolioUserId,
          project_objective: item.project_objective || '',
          project_description: item.project_description || '',
          industry: item.industry || '',
          project_files: item.project_files || []
        }));

        await axios.put(
          process.env.REACT_APP_TALENT_EDITPORTFOLIO,
          { educationdata: portfolioPayload, type: "PORT" },
          {
            headers: {
              Authorization: token,
              'Content-Type': 'application/json',
            },
          }
        );
      }

      // Refresh user data
      await dispatch(login(user.data[0].email, "candidate"));

      alert("Candidate Details Successfully Updated");
      setEdit(false);

    } catch (error) {
      console.error('Error updating profile:', error);
      alert("Failed to update candidate details.");
    } finally {
      setLoading(false);
    }
  };


  // Initial data fetching effect
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Set initial edit state based on profile
        if (user?.data?.[0]?.profile === 0) {
          setEdit(true);
        }

        // Initialize state with user data
        setState(prevState => ({
          ...prevState,
          fname: user?.data?.[0]?.firstName || "",
          mname: user?.data?.[0]?.middleName || "",
          lname: user?.data?.[0]?.lastName || "",
          area: user?.data?.[0]?.area || "",
          github_repo_name: user?.data?.[0]?.github_repo_name || "",
          github_username: user?.data?.[0]?.github_username || "",
          jira_username: user?.data?.[0]?.jira_username || "",
          sonarqube_project_key: user?.data?.[0]?.sonarqube_project_key || "",
          country: user?.data?.[0]?.country || "",
          job_title: user?.data?.[0]?.job_title || "",
          primaryskill: user?.data?.[0]?.primaryskill || "",
          portfolio: user?.data?.[0]?.portfolioUrl || "",
          linkedin: user?.data?.[0]?.linkedinUrl || "",
          github: user?.data?.[0]?.githubUrl || "",
          industry: user?.data?.[0]?.industry || "",
          about: user?.data?.[0]?.about || "",
          techStack: user?.data?.[0]?.techStack || "",
          email: user?.data?.[0]?.email || "",
          resume: user?.data?.[0]?.resume || "",
          coding_assessment_url: user?.data?.[0]?.coding_assessment_url || "",
          work_authorization: user?.data?.[0]?.work_authorization || "",
          timezone: user?.data?.[0]?.timezone || "",
          availability: user?.data?.[0]?.availability || "",
          hoursperweek: user?.data?.[0]?.hoursperweek || "",
          currentStatus: user?.data?.[0]?.currentStatus || "",
          availabledate: user?.data?.[0]?.availabledate || "",
          profilePicture: user?.data?.[0]?.profilePicture || "",
          calendlyurl: user?.data?.[0]?.calendlyurl || "",
          talent_code: user?.data?.[0]?.talent_code || "",
          ratePerhour: user?.data?.[0]?.ratePerhour || "",
          ratePermonth: user?.data?.[0]?.ratePermonth || "",
          currency: user?.data?.[0]?.currency || "",
          workhours: user?.data?.[0]?.workhours || ""
        }));

        // Fetch profile picture
        await generatePreSignedPutUrl11();
        await generateAndSetSignedUrlassessment();
        await generateAndSetSignedUrl();

        // Fetch candidate data
        const headers = {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        };

        const response = await axios.post(
          process.env.REACT_APP_CLIENT_GETCANDIDATEDATA,
          { id: user.data[0].c_id },
          { headers }
        );

        // Process response data
        const { podExperience, education, exp, certification } = response.data.data;

        setPod(podExperience);

        /* istanbul ignore next */
        if (education?.length > 0) {
          const educationData = education.map(data => ({
            degree: data.degree || "",
            domain: data.domain || "",
            institution: data.institution || "",
            startDate: data.startDate || "",
            candidateID: data.candidateID || "",
            endDate: data.endDate || "",
            id: data.id || ""
          }));
          setArrexp1(educationData);
        }

        /* istanbul ignore next */
        if (exp?.length > 0) {
          const experienceData = exp.map(data => ({
            work_organization: data.work_organization || "",
            work_position: data.work_position || "",
            present: data.present || 0,
            workStartdate: data.workStartdate || "",
            workEnddate: data.workEnddate || "",
            candidateID: data.candidateID || "",
            id: data.id || ""
          }));
          setUserexp(experienceData);
        }

        /* istanbul ignore next */
        if (certification?.length > 0) {
          const certificationData = certification.map(data => ({
            cert_name: data.cert_name || "",
            candidateID: data.candidateID || "",
            startDate: data.startDate ? moment(data.startDate).format("YYYY-MM-DD") : "",
            endDate: data.endDate ? moment(data.endDate).format("YYYY-MM-DD") : "",
            certUrl: data.certUrl || "",
            certificationInstitution: data.certificationInstitution || "",
            id: data.id || ""
          }));
          setArrCert(certificationData);
        }

      } catch (err) {
        console.error('Error fetching data:', err);
        setError('Failed to fetch profile data');
      }
    };

    if (token && user?.data?.[0]?.c_id) {
      fetchData();
    }
  }, [token, user]);

  AWS.config.update({

    region: credentials.region,
    accessKeyId: credentials.accessKeyId,
    secretAccessKey: credentials.secretAccessKey
  });


  /* istanbul ignore next */
  const uploadImageToS3 = async (imageFile) => {
    const imageKey = `portfolio-images/${uuidv4()}.png`;
    const uploadParams = {
      Bucket: process.env.REACT_APP_BUCKETNAME,
      Key: imageKey,
      Body: imageFile,
      ContentType: 'image/png',
    };

    try {
      const uploadResult = await s3.upload(uploadParams).promise();
      return uploadResult.Location;
    } catch (error) {
      console.error('Error uploading image to S3:', error);
      throw error;
    }
  };
  // Fetch portfolio data
  /* istanbul ignore next */
  useEffect(() => {
    const fetchPortfolioData = async () => {
      if (!token || !user?.data?.[0]) return;

      try {
        setLoading(true);
        const portfolioUserId = user.data[0].type === 'Provider' ? user.data[0].id : user.data[0].c_id;

        const response = await axios.post(
          process.env.REACT_APP_TALENT_LISTPORTFOLIO,
          { portfolio_user_id: portfolioUserId },
          {
            headers: {
              Authorization: token,
              'Content-Type': 'application/json',
            }
          }
        );

        if (response.data?.body) {
          setPortfolioItems(
            response.data.body.length > 0
              ? response.data.body
              : [{ project_objective: '', project_description: '', industry: '', project_files: [] }]
          );
        }
      } catch (error) {
        console.error('Error fetching portfolio data:', error);
        setError('Failed to fetch portfolio data');
      } finally {
        setLoading(false);
      }
    };

    fetchPortfolioData();
  }, [token, user]);

  // AWS S3 and CloudFront functions
  /* istanbul ignore next */
  const generatePreSignedPutUrl11 = async () => {
    try {
      if (!user?.data?.[0]?.profilePicture) return;

      const response = await fetch(
        process.env.REACT_APP_TALENT_CLOUDFRONTAPI,
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            url: process.env.REACT_APP_CLOUDFRONT + user.data[0].profilePicture
          })
        }
      );

      const data = await response.json();
      const signedUrl = JSON.parse(data.body).signedUrl;
      setAuthImage(signedUrl);
    } catch (error) {
      console.error("Error generating signed URL:", error);
      setError('Failed to load profile picture');
    }
  };
  /* istanbul ignore next */
  const generateAndSetSignedUrl = async () => {
    try {
      if (!state.resume) return;

      const response = await fetch(
        process.env.REACT_APP_TALENT_CLOUDFRONTAPI,
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            url: process.env.REACT_APP_CLOUDFRONT + state.resume
          })
        }
      );

      const data = await response.json();
      const signedUrl = JSON.parse(data.body).signedUrl;
      setResume(signedUrl);
    } catch (error) {
      console.error("Error generating signed URL:", error);
      setError('Failed to load resume URL');
    }
  };

  /* istanbul ignore next */
  const handleGetsignedURL = async (key) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_TALENT_CANDIDATEPROFILE_GETSIGNEDURL}`, {
        method: "POST",
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ key }),
      });

      const data = await response.json();
      const signedUrl = JSON.parse(data.body).signedUrl;
      setAssesment(signedUrl);
    } catch (error) {
      console.error("Error generating signed URL:", error);
      setError('Failed to load assessment URL');
    }
  };

  /* istanbul ignore next */
  const generateAndSetSignedUrlassessment = async () => {
    try {
      if (!state.coding_assessment_url) return;

      const response = await fetch(
        process.env.REACT_APP_TALENT_CLOUDFRONTAPI,
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            url: process.env.REACT_APP_CLOUDFRONT + state.coding_assessment_url
          })
        }
      );

      const data = await response.json();
      const signedUrl = JSON.parse(data.body).signedUrl;
      setAssesment(signedUrl);
    } catch (error) {
      console.error("Error generating signed URL:", error);
      setError('Failed to load assessment URL');
    }
  };

  // Component return
  return (
    <Box sx={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
      pt: 12,
      pb: 6,
      px: { xs: 2, md: 4 },
      marginLeft: collapsed ? "60px" : "240px",
      transition: 'all 0.3s ease',
    }}>
      <Container maxWidth="lg">
        <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: 2 }}>
          <Box>
            <Typography variant="h3" sx={{ fontWeight: 900, color: '#ffffff', mb: 1, letterSpacing: '-0.02em', textShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
              {edit
                ? (user?.data?.[0]?.profile === 0
                  ? intl.formatMessage({ id: 'createProfile' })
                  : intl.formatMessage({ id: 'updateProfile' }))
                : intl.formatMessage({ id: 'manageProfile' })}
            </Typography>

            <Stack direction="row" spacing={1} alignItems="center">
              <Button
                component={Link}
                to="/candidate-dashboard"
                sx={{ color: 'rgba(255, 255, 255, 0.7)', fontWeight: 700, '&:hover': { color: '#ffffff', background: 'transparent' } }}
              >
                {intl.formatMessage({ id: 'dashboard' })}
              </Button>
              <Typography sx={{ fontWeight: 700, color: '#ffffff', opacity: 0.5 }}>/</Typography>
              <Typography sx={{ fontWeight: 800, color: '#ffffff' }}>
                {intl.formatMessage({ id: 'manageProfile' })}
              </Typography>
            </Stack>
          </Box>

          {!edit && (
            <ActionButton
              onClick={() => toggleEdit(true)}
              startIcon={<EditIcon />}
            >
              {intl.formatMessage({ id: 'editProfile' }) || 'Edit Profile'}
            </ActionButton>
          )}
        </Box>

        <PremiumPaper elevation={0}>
          <Box sx={{
            p: 4,
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            background: 'linear-gradient(135deg, #1a237e 0%, #3f51b5 100%)',
            borderBottom: '1px solid rgba(255,255,255,0.1)',
            color: 'white'
          }}>
            <Box sx={{ position: 'relative' }}>
              <ProfileAvatar
                src={image || authImage || defaultimg}
                alt={state.fname}
                sx={{ width: 100, height: 100 }}
              />
              {edit && (
                <label htmlFor="profile-upload-header">
                  <IconButton
                    component="span"
                    sx={{
                      position: 'absolute',
                      bottom: -5,
                      right: -5,
                      bgcolor: 'primary.main',
                      color: 'white',
                      size: 'small',
                      '&:hover': { bgcolor: 'primary.dark' }
                    }}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                  <VisuallyHiddenInput id="profile-upload-header" type="file" onChange={onImageUpload} accept="image/*" />
                </label>
              )}
            </Box>
            <Box sx={{ color: 'white' }}>
              <Typography variant="h3" sx={{
                fontWeight: 900,
                color: 'white',
                letterSpacing: '-1px',
                fontFamily: "'Inter', 'Segoe UI', sans-serif"
              }}>
                {state.fname} {state.lname}
              </Typography>
              <Typography variant="h6" sx={{ fontWeight: 600, mt: -0.5, opacity: 0.9, color: 'white' }}>
                {state.job_title || (intl.formatMessage({ id: 'candidate' }) || 'Candidate')}
              </Typography>
              <Stack direction="row" spacing={1} sx={{ mt: 1.5 }}>
                {state.primaryskill && (
                  <Chip
                    label={state.primaryskill}
                    size="small"
                    sx={{
                      borderRadius: '8px',
                      background: 'linear-gradient(45deg, #1a237e, #3f51b5)',
                      color: 'white',
                      fontWeight: 700,
                      px: 1
                    }}
                  />
                )}
                {state.techStack && (
                  <Chip
                    label={state.techStack}
                    size="small"
                    sx={{
                      borderRadius: '8px',
                      background: 'rgba(33, 150, 243, 0.1)',
                      color: '#1976d2',
                      fontWeight: 700,
                      border: '1px solid rgba(33, 150, 243, 0.3)',
                      px: 1
                    }}
                  />
                )}
              </Stack>
            </Box>
          </Box>
          <Box sx={{
            background: 'linear-gradient(135deg, #1a237e 0%, #3f51b5 100%)',
            px: 3,
            pt: 1,
            borderBottom: '1px solid rgba(255,255,255,0.1)'
          }}>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                '& .MuiTabs-indicator': {
                  height: 3,
                  borderRadius: '3px 3px 0 0',
                  background: '#ffffff',
                }
              }}
            >
              <StyledTab label={intl.formatMessage({ id: 'basicInformation' })} />
              <StyledTab label={intl.formatMessage({ id: 'skillsAndExpertise' })} />
              <StyledTab label={intl.formatMessage({ id: 'education' })} />
              <StyledTab label={intl.formatMessage({ id: 'workExperience' })} />
              <StyledTab label={intl.formatMessage({ id: 'certifications' })} />
              <StyledTab label={intl.formatMessage({ id: 'portfolio' })} />
              <StyledTab label={intl.formatMessage({ id: 'otherInformation' })} />
            </Tabs>
          </Box>

          {error && (
            <Box sx={{ p: 2 }}>
              <Alert severity="error" variant="filled" sx={{ borderRadius: '12px' }}>
                {error}
              </Alert>
            </Box>
          )}

          <form onSubmit={handleSubmit}>
            <Box sx={{ p: 3 }}>
              {tabValue === 0 && (
                <Box sx={{ mt: 3 }}>
                  <Grid container spacing={4}>
                    <Grid item xs={12} md={4} sx={{ textAlign: 'center' }}>
                      <Box sx={{ position: 'relative', display: 'inline-block' }}>
                        <ProfileAvatar
                          src={image || authImage || defaultimg}
                          alt={state.fname}
                        />
                        {edit && (
                          <label htmlFor="profile-upload">
                            <IconButton
                              component="span"
                              sx={{
                                position: 'absolute',
                                bottom: 4,
                                right: 4,
                                bgcolor: 'primary.main',
                                color: 'white',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                                '&:hover': { bgcolor: 'primary.dark', transform: 'scale(1.1)' },
                                transition: 'all 0.2s ease'
                              }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                            <VisuallyHiddenInput
                              id="profile-upload"
                              type="file"
                              onChange={onImageUpload}
                              accept="image/*"
                            />
                          </label>
                        )}
                      </Box>
                      <Typography variant="body2" sx={{ mt: 2, fontWeight: 600, color: 'rgba(255, 255, 255, 0.7)' }}>
                        {intl.formatMessage({ id: 'profilePicture' }) || 'Profile Picture'}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={8}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={4}>
                          <ModernTextField
                            fullWidth
                            label={intl.formatMessage({ id: 'firstName' })}
                            value={state.fname || ""}
                            onChange={onInputChange}
                            id="fname"
                            disabled={!edit}
                            required
                          />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                          <ModernTextField
                            fullWidth
                            label={intl.formatMessage({ id: 'middleName' })}
                            value={state.mname || ""}
                            onChange={onInputChange}
                            id="mname"
                            disabled={!edit}
                          />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                          <ModernTextField
                            fullWidth
                            label={intl.formatMessage({ id: 'lastName' })}
                            value={state.lname || ""}
                            onChange={onInputChange}
                            id="lname"
                            disabled={!edit}
                            required
                          />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <FormControl fullWidth variant="outlined">
                            <InputLabel id="country-label" sx={{ fontWeight: 600, color: 'rgba(255, 255, 255, 0.6)' }}>
                              {intl.formatMessage({ id: 'country' })}
                            </InputLabel>
                            <Select
                              labelId="country-label"
                              value={state.country || ""}
                              onChange={onInputChangeselect}
                              name="country"
                              disabled={!edit}
                              label={intl.formatMessage({ id: 'country' })}
                              sx={{ borderRadius: '14px', backgroundColor: 'rgba(255, 255, 255, 0.05)', color: '#ffffff', '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.1)' }, '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.3)' }, '& .MuiSvgIcon-root': { color: 'rgba(255, 255, 255, 0.7)' } }}
                            >
                              {country.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                  {option.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                          <ModernTextField
                            fullWidth
                            multiline
                            rows={4}
                            label={intl.formatMessage({ id: 'about' })}
                            value={state.about || ""}
                            onChange={onInputChange}
                            id="about"
                            inputProps={{ maxLength: 1000 }}
                            disabled={!edit}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
              )}

              {tabValue === 1 && (
                <Box sx={{ mt: 3 }}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth variant="outlined">
                        <InputLabel id="primary-skill-label" sx={{ fontWeight: 600, color: 'rgba(255, 255, 255, 0.6)' }}>
                          {intl.formatMessage({ id: 'primarySkill' })}
                        </InputLabel>
                        <Select
                          labelId="primary-skill-label"
                          value={state.primaryskill || ""}
                          onChange={onInputChangeselect}
                          name="primaryskill"
                          disabled={!edit}
                          label={intl.formatMessage({ id: 'primarySkill' })}
                          sx={{ borderRadius: '14px', backgroundColor: 'rgba(255, 255, 255, 0.05)', color: '#ffffff', '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.1)' }, '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.3)' }, '& .MuiSvgIcon-root': { color: 'rgba(255, 255, 255, 0.7)' } }}
                        >
                          {area.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <ModernTextField
                        fullWidth
                        label={intl.formatMessage({ id: 'secondarySkill' }) || "Secondary Skill"}
                        value={state.secondaryskill || ""}
                        onChange={onInputChange}
                        id="secondaryskill"
                        disabled={!edit}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth variant="outlined">
                        <InputLabel id="tech-stack-label" sx={{ fontWeight: 600, color: 'rgba(255, 255, 255, 0.6)' }}>
                          {intl.formatMessage({ id: 'techStack' })}
                        </InputLabel>
                        <Select
                          labelId="tech-stack-label"
                          value={state.techStack || ""}
                          onChange={onInputChangeselect}
                          name="techStack"
                          disabled={!edit}
                          label={intl.formatMessage({ id: 'techStack' })}
                          sx={{ borderRadius: '14px', backgroundColor: 'rgba(255, 255, 255, 0.05)', color: '#ffffff', '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.1)' }, '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.3)' }, '& .MuiSvgIcon-root': { color: 'rgba(255, 255, 255, 0.7)' } }}
                        >
                          {techStack.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth variant="outlined">
                        <InputLabel id="job-title-label" sx={{ fontWeight: 600, color: 'rgba(255, 255, 255, 0.6)' }}>
                          {intl.formatMessage({ id: 'jobTitle' })}
                        </InputLabel>
                        <Select
                          labelId="job-title-label"
                          value={state.job_title || ""}
                          onChange={onInputChangeselect}
                          name="job_title"
                          disabled={!edit}
                          label={intl.formatMessage({ id: 'jobTitle' })}
                          sx={{ borderRadius: '14px', backgroundColor: 'rgba(255, 255, 255, 0.05)', color: '#ffffff', '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.1)' }, '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.3)' }, '& .MuiSvgIcon-root': { color: 'rgba(255, 255, 255, 0.7)' } }}
                        >
                          {jobTitleOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth variant="outlined">
                        <InputLabel id="industry-label" sx={{ fontWeight: 600, color: 'rgba(255, 255, 255, 0.6)' }}>
                          {intl.formatMessage({ id: 'industry' })}
                        </InputLabel>
                        <Select
                          labelId="industry-label"
                          value={state.industry || ""}
                          onChange={onInputChangeselect}
                          name="industry"
                          disabled={!edit}
                          label={intl.formatMessage({ id: 'industry' })}
                          sx={{ borderRadius: '14px', backgroundColor: 'rgba(255, 255, 255, 0.05)', color: '#ffffff', '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.1)' }, '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.3)' }, '& .MuiSvgIcon-root': { color: 'rgba(255, 255, 255, 0.7)' } }}
                        >
                          {industry.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Box>
              )}

              {/* Education Section */}
              {tabValue === 2 && (
                <Box sx={{ mt: 3 }}>
                  <Stack spacing={3}>
                    {arrexp1.map((item, idx) => (
                      <Card key={idx} variant="outlined" sx={{ borderRadius: '16px', background: 'rgba(255, 255, 255, 0.03)', border: '1px solid rgba(255, 255, 255, 0.08)' }}>
                        <CardContent>
                          <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} sm={4}>
                              <ModernTextField
                                fullWidth
                                label={intl.formatMessage({ id: 'degree' })}
                                id="degree"
                                value={item.degree}
                                onChange={(e) => handleChange(e, idx)}
                                disabled={!edit}
                              />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                              <ModernTextField
                                fullWidth
                                label={intl.formatMessage({ id: 'domain' }) || "Domain/Major"}
                                id="domain"
                                value={item.domain}
                                onChange={(e) => handleChange(e, idx)}
                                disabled={!edit}
                              />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                              <ModernTextField
                                fullWidth
                                label={intl.formatMessage({ id: 'institution' })}
                                id="institution"
                                value={item.institution}
                                onChange={(e) => handleChange(e, idx)}
                                disabled={!edit}
                              />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                              <ModernTextField
                                fullWidth
                                label={intl.formatMessage({ id: 'startDate' })}
                                id="startDate"
                                type="date"
                                value={item.startDate}
                                onChange={(e) => handleChange(e, idx)}
                                disabled={!edit}
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                              <ModernTextField
                                fullWidth
                                label={intl.formatMessage({ id: 'endDate' })}
                                id="endDate"
                                type="date"
                                value={item.endDate}
                                onChange={(e) => handleChange(e, idx)}
                                disabled={!edit}
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>
                            {edit && (
                              <Grid item xs={12} sm={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <IconButton onClick={() => removeEducation(idx)} color="error" size="small">
                                  <DeleteIcon />
                                </IconButton>
                              </Grid>
                            )}
                          </Grid>
                        </CardContent>
                      </Card>
                    ))}
                    {edit && (
                      <Button startIcon={<AddIcon />} onClick={addInput} sx={{ alignSelf: 'flex-start', borderRadius: '10px', color: '#64b5f6' }}>
                        {intl.formatMessage({ id: 'addEducation' }) || 'Add Education'}
                      </Button>
                    )}
                  </Stack>
                </Box>
              )}

              {/* Work Experience Section */}
              {tabValue === 3 && (
                <Box sx={{ mt: 3 }}>
                  <Stack spacing={3}>
                    {userexp.map((item, idx) => (
                      <Card key={idx} variant="outlined" sx={{ borderRadius: '16px', background: 'rgba(255, 255, 255, 0.03)', border: '1px solid rgba(255, 255, 255, 0.08)' }}>
                        <CardContent>
                          <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} sm={4}>
                              <ModernTextField
                                fullWidth
                                label={intl.formatMessage({ id: 'organization' })}
                                value={item.work_organization}
                                onChange={(e) => handleChangeExp(e, idx, 'work_organization')}
                                disabled={!edit}
                              />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                              <ModernTextField
                                fullWidth
                                label={intl.formatMessage({ id: 'position' })}
                                value={item.work_position}
                                onChange={(e) => handleChangeExp(e, idx, 'work_position')}
                                disabled={!edit}
                              />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                              <ModernTextField
                                fullWidth
                                label={intl.formatMessage({ id: 'startDate' })}
                                type="date"
                                value={item.workStartdate}
                                onChange={(e) => handleChangeExp(e, idx, 'workStartdate')}
                                disabled={!edit}
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                              <ModernTextField
                                fullWidth
                                label={intl.formatMessage({ id: 'endDate' })}
                                type="date"
                                value={item.workEnddate}
                                onChange={(e) => handleChangeExp(e, idx, 'workEnddate')}
                                disabled={!edit || item.present === 1}
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>
                            {edit && (
                              <Grid item xs={12} sm={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <IconButton onClick={() => removeExperience(idx)} color="error" size="small">
                                  <DeleteIcon />
                                </IconButton>
                              </Grid>
                            )}
                            <Grid item xs={12}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={item.present === 1}
                                    onChange={(e) => handleChangeExp(e, idx, 'present')}
                                    disabled={!edit}
                                  />
                                }
                                label={<Typography sx={{ color: 'rgba(255, 255, 255, 0.8)', fontWeight: 500 }}>{intl.formatMessage({ id: 'currentlyWorking' }) || "Currently working here"}</Typography>}
                              />
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    ))}
                    {edit && (
                      <Button startIcon={<AddIcon />} onClick={addExp} sx={{ alignSelf: 'flex-start', borderRadius: '10px', color: '#64b5f6' }}>
                        {intl.formatMessage({ id: 'addExperience' }) || 'Add Experience'}
                      </Button>
                    )}
                  </Stack>
                </Box>
              )}

              {/* Certifications Section */}
              {tabValue === 4 && (
                <Box sx={{ mt: 3 }}>
                  <Stack spacing={3}>
                    {arrCert.map((item, idx) => (
                      <Card key={idx} variant="outlined" sx={{ borderRadius: '16px', background: 'rgba(255, 255, 255, 0.03)', border: '1px solid rgba(255, 255, 255, 0.08)' }}>
                        <CardContent>
                          <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} sm={4}>
                              <ModernTextField
                                fullWidth
                                label={intl.formatMessage({ id: 'certificationName' })}
                                id="cert_name"
                                value={item.cert_name}
                                onChange={(e) => handleChangeCert(e, idx)}
                                disabled={!edit}
                              />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                              <ModernTextField
                                fullWidth
                                label={intl.formatMessage({ id: 'certUrl' }) || "Certification Link"}
                                id="certUrl"
                                value={item.certUrl}
                                onChange={(e) => handleChangeCert(e, idx)}
                                disabled={!edit}
                              />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                              <ModernTextField
                                fullWidth
                                label={intl.formatMessage({ id: 'institution' })}
                                id="certificationInstitution"
                                value={item.certificationInstitution}
                                onChange={(e) => handleChangeCert(e, idx)}
                                disabled={!edit}
                              />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                              <ModernTextField
                                fullWidth
                                label={intl.formatMessage({ id: 'startDate' })}
                                id="startDate"
                                type="date"
                                value={item.startDate}
                                onChange={(e) => handleChangeCert(e, idx)}
                                disabled={!edit}
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                              <ModernTextField
                                fullWidth
                                label={intl.formatMessage({ id: 'endDate' })}
                                id="endDate"
                                type="date"
                                value={item.endDate}
                                onChange={(e) => handleChangeCert(e, idx)}
                                disabled={!edit}
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>
                            {edit && (
                              <Grid item xs={12} sm={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <IconButton onClick={() => removeCertification(idx)} color="error" size="small">
                                  <DeleteIcon />
                                </IconButton>
                              </Grid>
                            )}
                          </Grid>
                        </CardContent>
                      </Card>
                    ))}
                    {edit && (
                      <Button startIcon={<AddIcon />} onClick={addCert} sx={{ alignSelf: 'flex-start', borderRadius: '10px', color: '#64b5f6' }}>
                        {intl.formatMessage({ id: 'addCertification' }) || 'Add Certification'}
                      </Button>
                    )}
                  </Stack>
                </Box>
              )}

              {/* Portfolio Section */}
              {tabValue === 5 && (
                <Box sx={{ mt: 3 }}>
                  <Stack spacing={4}>
                    {portfolioItems.map((item, idx) => (
                      <Card key={idx} variant="outlined" sx={{ borderRadius: '20px', background: 'rgba(255, 255, 255, 0.03)', border: '1px solid rgba(255, 255, 255, 0.08)', overflow: 'hidden' }}>
                        <Box sx={{ p: 3, bgcolor: 'rgba(255, 255, 255, 0.02)' }}>
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                              <ModernTextField
                                fullWidth
                                label={intl.formatMessage({ id: 'projectObjective' })}
                                value={item.project_objective}
                                onChange={(e) => {
                                  const updated = [...portfolioItems];
                                  updated[idx].project_objective = e.target.value;
                                  setPortfolioItems(updated);
                                }}
                                disabled={!edit}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <ModernTextField
                                fullWidth
                                label={intl.formatMessage({ id: 'industry' })}
                                value={item.industry}
                                onChange={(e) => {
                                  const updated = [...portfolioItems];
                                  updated[idx].industry = e.target.value;
                                  setPortfolioItems(updated);
                                }}
                                disabled={!edit}
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <ModernTextField
                                fullWidth
                                multiline
                                rows={3}
                                label={intl.formatMessage({ id: 'projectDescription' })}
                                value={item.project_description}
                                onChange={(e) => {
                                  const updated = [...portfolioItems];
                                  updated[idx].project_description = e.target.value;
                                  setPortfolioItems(updated);
                                }}
                                disabled={!edit}
                              />
                            </Grid>
                            {edit && (
                              <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <IconButton onClick={() => removePortfolioItem(idx)} color="error" size="small">
                                  <DeleteIcon />
                                </IconButton>
                              </Grid>
                            )}
                          </Grid>
                        </Box>
                      </Card>
                    ))}
                    {edit && (
                      <Button startIcon={<AddIcon />} onClick={addNewPortfolioItem} sx={{ alignSelf: 'flex-start', borderRadius: '10px', color: '#64b5f6' }}>
                        {intl.formatMessage({ id: 'addPortfolioItem' }) || 'Add Portfolio Item'}
                      </Button>
                    )}
                  </Stack>
                </Box>
              )}

              {/* Other Information Section */}
              {tabValue === 6 && (
                <Box sx={{ mt: 3 }}>
                  <LanguageSelector currentLocale={currentLocale} changeLocale={changeLocale} />
                  <Grid container spacing={3} sx={{ mt: 1 }}>
                    <Grid item xs={12} md={6}>
                      <ModernTextField
                        fullWidth
                        label={intl.formatMessage({ id: 'portfolioUrl' })}
                        value={state.portfolio || ""}
                        onChange={onInputChange}
                        id="portfolio"
                        disabled={!edit}
                        type="url"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <ModernTextField
                        fullWidth
                        label={intl.formatMessage({ id: 'linkedInUrl' })}
                        value={state.linkedin || ""}
                        onChange={onInputChange}
                        id="linkedin"
                        disabled={!edit}
                        type="url"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <ModernTextField
                        fullWidth
                        label={intl.formatMessage({ id: 'githubUrl' }) || "Github URL"}
                        value={state.github || ""}
                        onChange={onInputChange}
                        id="github"
                        disabled={!edit}
                        type="url"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <ModernTextField
                        fullWidth
                        label={intl.formatMessage({ id: 'githubRepo' }) || "Github Repo Name"}
                        value={state.github_repo_name || ""}
                        onChange={onInputChange}
                        id="github_repo_name"
                        disabled={!edit}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <ModernTextField
                        fullWidth
                        label={intl.formatMessage({ id: 'githubUsername' }) || "Github Username"}
                        value={state.github_username || ""}
                        onChange={onInputChange}
                        id="github_username"
                        disabled={!edit}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth variant="outlined">
                        <InputLabel id="workhours-label" sx={{ fontWeight: 600, color: 'rgba(255, 255, 255, 0.6)' }}>
                          {intl.formatMessage({ id: 'prefferedWorkHours' })}
                        </InputLabel>
                        <Select
                          labelId="workhours-label"
                          value={state.workhours || ""}
                          onChange={onInputChangeselect}
                          name="workhours"
                          disabled={!edit}
                          label={intl.formatMessage({ id: 'prefferedWorkHours' })}
                          sx={{ borderRadius: '14px', backgroundColor: 'rgba(255, 255, 255, 0.05)', color: '#ffffff', '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.1)' }, '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.3)' }, '& .MuiSvgIcon-root': { color: 'rgba(255, 255, 255, 0.7)' } }}
                        >
                          <MenuItem value="Morning Shift, 9am - 6pm">Morning Shift, 9am - 6pm</MenuItem>
                          <MenuItem value="Evening Shift, 10pm - 7am">Evening Shift, 10pm - 7am</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    {user?.data?.[0]?.talent_type !== "PARTNER" && (
                      <Grid item xs={12} md={6}>
                        <ModernTextField
                          fullWidth
                          label={intl.formatMessage({ id: 'ratePerHour' })}
                          value={state.ratePerhour || ""}
                          onChange={onInputChange}
                          id="ratePerhour"
                          disabled={!edit}
                          type="number"
                        />
                      </Grid>
                    )}

                    <Grid item xs={12} md={6}>
                      <ModernTextField
                        fullWidth
                        label={intl.formatMessage({ id: 'calendlyurl' })}
                        value={state.calendlyurl || ""}
                        onChange={onInputChange}
                        id="calendlyurl"
                        disabled={!edit}
                        type="url"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <ModernTextField
                        fullWidth
                        label={intl.formatMessage({ id: 'talentCode' })}
                        value={state.talent_code || ""}
                        onChange={onInputChange}
                        id="talent_code"
                        disabled
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth variant="outlined">
                        <InputLabel id="currency-label" sx={{ fontWeight: 600, color: 'rgba(255, 255, 255, 0.6)' }}>
                          {intl.formatMessage({ id: 'currency' })}
                        </InputLabel>
                        <Select
                          labelId="currency-label"
                          value={state.currency || ""}
                          onChange={onInputChangeselect}
                          name="currency"
                          disabled={!edit}
                          label={intl.formatMessage({ id: 'currency' })}
                          sx={{ borderRadius: '14px', backgroundColor: 'rgba(255, 255, 255, 0.05)', color: '#ffffff', '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.1)' }, '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.3)' }, '& .MuiSvgIcon-root': { color: 'rgba(255, 255, 255, 0.7)' } }}
                        >
                          <MenuItem value="USD">USD</MenuItem>
                          <MenuItem value="INR">INR</MenuItem>
                          <MenuItem value="CRC">CRC</MenuItem>
                          <MenuItem value="Vietnamese Dong">Vietnamese Dong</MenuItem>
                          <MenuItem value="Colombian Pesos">Colombian Pesos</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth variant="outlined">
                        <InputLabel id="availability-label" sx={{ fontWeight: 600, color: 'rgba(255, 255, 255, 0.6)' }}>
                          {intl.formatMessage({ id: 'availability' })}
                        </InputLabel>
                        <Select
                          labelId="availability-label"
                          value={state.availability || ""}
                          onChange={onInputChangeselect}
                          name="availability"
                          disabled={!edit}
                          label={intl.formatMessage({ id: 'availability' })}
                          sx={{ borderRadius: '14px', backgroundColor: 'rgba(255, 255, 255, 0.05)', color: '#ffffff', '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.1)' }, '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.3)' }, '& .MuiSvgIcon-root': { color: 'rgba(255, 255, 255, 0.7)' } }}
                        >
                          <MenuItem value="full time">Full Time</MenuItem>
                          <MenuItem value="part time">Part Time</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    {state.availability === "part time" && (
                      <Grid item xs={12} md={6}>
                        <ModernTextField
                          fullWidth
                          label={intl.formatMessage({ id: 'hoursPerWeek' })}
                          value={state.hoursperweek || ""}
                          onChange={onInputChange}
                          id="hoursperweek"
                          disabled={!edit}
                          type="number"
                        />
                      </Grid>
                    )}

                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth variant="outlined">
                        <InputLabel id="timezone-label" sx={{ fontWeight: 500 }}>
                          {intl.formatMessage({ id: 'timeZone' })}
                        </InputLabel>
                        <Select
                          labelId="timezone-label"
                          value={state.timezone || ""}
                          onChange={onInputChangeselect}
                          name="timezone"
                          disabled={!edit}
                          label={intl.formatMessage({ id: 'timeZone' })}
                          sx={{ borderRadius: '14px', backgroundColor: 'rgba(255, 255, 255, 0.5)' }}
                        >
                          <MenuItem value="indian_standard_time">Indian Standard Time</MenuItem>
                          <MenuItem value="eastern_standard_time">Eastern Standard Time</MenuItem>
                          <MenuItem value="central_standard_time">Central Standard Time</MenuItem>
                          <MenuItem value="mountain_standard_time">Mountain Standard Time</MenuItem>
                          <MenuItem value="pacific_standard_time">Pacific Standard Time</MenuItem>
                          <MenuItem value="greenwich_mean_time">Greenwich Mean Time</MenuItem>
                          <MenuItem value="central_european_time">Central European Time</MenuItem>
                          <MenuItem value="western_european_time">Western European Time</MenuItem>
                          <MenuItem value="australian_eastern_standard_time">Australian Eastern Standard Time</MenuItem>
                          <MenuItem value="australian_central_standard_time">Australian Central Standard Time</MenuItem>
                          <MenuItem value="australian_western_standard_time">Australian Western Standard Time</MenuItem>
                          <MenuItem value="new_york_time">New York Time (Eastern Daylight Time)</MenuItem>
                          <MenuItem value="los_angeles_time">Los Angeles Time (Pacific Daylight Time)</MenuItem>
                          <MenuItem value="london_time">London Time (British Summer Time)</MenuItem>
                          <MenuItem value="paris_time">Paris Time (Central European Summer Time)</MenuItem>
                          <MenuItem value="tokyo_time">Tokyo Time (Japan Standard Time)</MenuItem>
                          <MenuItem value="sydney_time">Sydney Time (Australian Eastern Daylight Time)</MenuItem>
                          <MenuItem value="dubai_time">Dubai Time (Gulf Standard Time)</MenuItem>
                          <MenuItem value="moscow_time">Moscow Time (Moscow Standard Time)</MenuItem>
                          <MenuItem value="brazil_time">Brazil Time (Brasilia Time)</MenuItem>
                          <MenuItem value="chicago_time">Chicago Time (Central Daylight Time)</MenuItem>
                          <MenuItem value="houston_time">Houston Time (Central Daylight Time)</MenuItem>
                          <MenuItem value="cape_town_time">Cape Town Time (South Africa Standard Time)</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth variant="outlined">
                        <InputLabel id="status-label" sx={{ fontWeight: 500 }}>
                          {intl.formatMessage({ id: 'currentlyAvailable' })}
                        </InputLabel>
                        <Select
                          labelId="status-label"
                          value={state.currentStatus || ""}
                          onChange={onInputChangeselect}
                          name="currentStatus"
                          disabled={!edit}
                          label={intl.formatMessage({ id: 'currentlyAvailable' })}
                          sx={{ borderRadius: '14px', backgroundColor: 'rgba(255, 255, 255, 0.5)' }}
                        >
                          <MenuItem value="Yes">Yes</MenuItem>
                          <MenuItem value="No">No</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    {state.currentStatus === "No" && (
                      <Grid item xs={12} md={6}>
                        <ModernTextField
                          fullWidth
                          label={intl.formatMessage({ id: 'availableDate' })}
                          type="date"
                          value={state.availabledate || ""}
                          onChange={onInputChange}
                          id="availabledate"
                          disabled={!edit}
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid>
                    )}

                    <Grid item xs={12} md={6}>
                      <Box sx={{ p: 2, border: '2px dashed rgba(0,0,0,0.1)', borderRadius: '14px', textAlign: 'center' }}>
                        <input
                          accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                          style={{ display: 'none' }}
                          id="coding-assessment-upload"
                          type="file"
                          onChange={onFileUploadassesment}
                          disabled={!edit}
                        />
                        <label htmlFor="coding-assessment-upload">
                          <Button
                            variant="text"
                            component="span"
                            startIcon={<CloudUploadIcon />}
                            disabled={!edit}
                            sx={{ fontWeight: 600 }}
                          >
                            {intl.formatMessage({ id: 'uploadAssessment' })}
                          </Button>
                        </label>
                        {state.coding_assessment_url && (
                          <Typography variant="caption" display="block" color="success.main" sx={{ mt: 1, fontWeight: 500 }}>
                            {state.coding_assessment_url.split('/').pop()}
                          </Typography>
                        )}
                      </Box>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Box sx={{ p: 2, border: '2px dashed rgba(0,0,0,0.1)', borderRadius: '14px', textAlign: 'center' }}>
                        <input
                          accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                          style={{ display: 'none' }}
                          id="resume-upload"
                          type="file"
                          onChange={onFileUpload}
                          disabled={!edit}
                        />
                        <label htmlFor="resume-upload">
                          <Button
                            variant="text"
                            component="span"
                            startIcon={<CloudUploadIcon />}
                            disabled={!edit}
                            sx={{ fontWeight: 600 }}
                          >
                            {intl.formatMessage({ id: 'uploadResume' })}
                          </Button>
                        </label>
                        {state.resume && (
                          <Typography variant="caption" display="block" color="success.main" sx={{ mt: 1, fontWeight: 500 }}>
                            {state.resume.split('/').pop()}
                          </Typography>
                        )}
                      </Box>
                    </Grid>


                    {(resume || assesment) && (
                      <Grid item xs={12}>
                        <Stack direction="row" spacing={2} justifyContent="center" sx={{ mt: 2 }}>
                          {resume && (
                            <Button
                              variant="outlined"
                              color="primary"
                              startIcon={<LinkIcon />}
                              href={resume}
                              target="_blank"
                              rel="noopener noreferrer"
                              sx={{ borderRadius: '10px' }}
                            >
                              {intl.formatMessage({ id: 'viewResume' })}
                            </Button>
                          )}
                          {assesment && (
                            <Button
                              variant="outlined"
                              color="primary"
                              startIcon={<LinkIcon />}
                              href={assesment}
                              target="_blank"
                              rel="noopener noreferrer"
                              sx={{ borderRadius: '10px' }}
                            >
                              {intl.formatMessage({ id: 'viewAssessment' })}
                            </Button>
                          )}
                        </Stack>
                      </Grid>
                    )}
                  </Grid>
                </Box>
              )}

              {/* Submit Button Section */}
              {edit && (
                <Box sx={{
                  mt: 6,
                  pt: 4,
                  borderTop: '1px solid rgba(0,0,0,0.05)',
                  display: 'flex',
                  justifyContent: 'center',
                  gap: 3
                }}>
                  <ActionButton
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      user?.data?.[0]?.profile === 1
                        ? intl.formatMessage({ id: 'update' })
                        : intl.formatMessage({ id: 'createProfile' })
                    )}
                  </ActionButton>
                  <Button
                    variant="text"
                    onClick={() => toggleEdit(false)}
                    disabled={loading}
                    sx={{
                      borderRadius: '14px',
                      px: 4,
                      color: 'text.secondary',
                      fontWeight: 700,
                      '&:hover': { background: 'rgba(0,0,0,0.04)' }
                    }}
                  >
                    {intl.formatMessage({ id: 'cancel' })}
                  </Button>
                </Box>
              )}
            </Box>
          </form>
        </PremiumPaper>
      </Container>
    </Box>
  );
};

export default Updateyourprofile;
